module.exports = __webpack_public_path__ + "img/tutorial4.8cccc57d.png";